import { h, render } from 'preact';
import CountrySelector from './country-selector';

export default (element, data) => {
  const init = () => {
    render(<CountrySelector {...data} />, element);
  };

  init();
};
